import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAuth } from "firebase/auth";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";
import { getMessaging } from "firebase/messaging";
import { initializeAppCheck, ReCaptchaEnterpriseProvider } from "firebase/app-check";
import { connectAuthEmulator } from "firebase/auth";
import { connectFirestoreEmulator } from "firebase/firestore";
import { connectStorageEmulator } from "firebase/storage";

// Firebase — Entorno de pruebas / Sandbox (kondify-app-dev)
export const firebaseConfig = {
  apiKey: "AIzaSyCYHBJMdD3JFRSyty-wax7SFoRTTc6CDS0",
  authDomain: "kondify-app-dev.firebaseapp.com",
  projectId: "kondify-app-dev",
  storageBucket: "kondify-app-dev.firebasestorage.app",
  messagingSenderId: "14800490709",
  appId: "1:14800490709:web:0f1886e85550e76f78925c",
  measurementId: "G-1TGB1LR1LQ"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Inicializar App Check
if (typeof window !== 'undefined') {
  if (window.location.hostname === "localhost") {
    window.FIREBASE_APPCHECK_DEBUG_TOKEN = true;
  }
  try {
    initializeAppCheck(app, {
      provider: new ReCaptchaEnterpriseProvider('6LdBS3ktAAAAAPaXBXfRF5lxR2qK52y2tJ5k34Lc'), // Clave de reCAPTCHA Enterprise
      isTokenAutoRefreshEnabled: true
    });
  } catch (err) {
    console.warn("App Check failed to initialize:", err);
  }
}

// Inicializa todos los servicios
export let analytics;
if (typeof window !== 'undefined') {
  try {
    analytics = getAnalytics(app);
  } catch (e) {
    console.warn("Analytics not supported in this environment:", e);
  }
}
export const db = getFirestore(app);
export const storage = getStorage(app);
export const auth = getAuth(app);
export const functions = getFunctions(app);
export let messaging;
if (typeof window !== 'undefined' && typeof navigator !== 'undefined') {
  try {
    messaging = getMessaging(app);
  } catch (e) {
    console.warn("Firebase Messaging not supported in this environment (likely Native).");
  }
}

if (typeof window !== 'undefined' && process.env.REACT_APP_USE_EMULATORS === 'true') {
  console.log("Conectando a Firebase Emulators...");
  connectAuthEmulator(auth, "http://localhost:9099", { disableWarnings: true });
  connectFirestoreEmulator(db, 'localhost', 8080);
  connectStorageEmulator(storage, 'localhost', 9199);
  connectFunctionsEmulator(functions, "localhost", 5002);
}